import { AxiosError } from "axios";
import { LoadingBlurDiv } from "@shared/components";
import { useTermsOfUseQuery } from "../api";
import { buildAssetUrl } from "@shared/utils";
import TermsOfUseTab from "../components/organisms/TermsOfUseTab";

const TermsOfUsePage = () => {
  const { data, error, isFetching } = useTermsOfUseQuery();

  const isNotFound = (error as AxiosError)?.response?.status === 404;
  const storagePath = data?.storagePath ? buildAssetUrl(data.storagePath) : undefined;

  return (
    <LoadingBlurDiv isLoading={isFetching}>
      <TermsOfUseTab
        storagePath={storagePath}
        isFetching={isFetching}
        isNotFound={isNotFound}
      />
    </LoadingBlurDiv>
  );
};

export default TermsOfUsePage;

